import { createContext } from "react";

import { DEFAULT_SLOT_INTERVAL, DEFAULT_HOUR_FORMAT } from "./constants";

// To avoid prop drilling `allowAddPeriod` to `ScheduleRow` component
// eslint-disable-next-line @bigbinary/neeto/use-zustand-for-global-state-management
const ScheduleContext = createContext({
  allowAddPeriod: true,
  firstDay: 0,
  slotInterval: DEFAULT_SLOT_INTERVAL,
  hourFormat: DEFAULT_HOUR_FORMAT,
});

export default ScheduleContext;
